import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSkip = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Skip</title>
    <path
      d="M7.664 9.094c0-1.118 1.294-1.74 2.167-1.041l9.866 7.893a1.333 1.333 0 0 1 0 2.083l-9.866 7.893c-.873.698-2.167.077-2.167-1.041V9.094ZM26.333 7.653v18.669"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSkip;
